const firebase = require('firebase/app')
require('firebase/auth')
require('firebase/database')
require('firebase/storage')
let config = {
  apiKey: 'AIzaSyAMvgytQXAbilvTvM2y5147FTzuhaztGhQ',
  authDomain: 'tellus-2017.firebaseapp.com',
  databaseURL: 'https://tellus-2017.firebaseio.com',
  projectId: 'tellus-2017',
  storageBucket: 'tellus-2017.appspot.com',
  messagingSenderId: '1016160619496'
}
let firebasePaths = {
  user: 'user',
  waterChemistry: 'waterChem',
  maps: 'wellMaps',
  wellDepth: 'wellDepth',
  wellMaps: 'wellMaps',
  wells: 'wells'
}
export let fireFetch = {
  chemistry: function (project) {
    return firebaseApp.database().ref(project + '/' + firebasePaths.waterChemistry)
  },
  wellDepth: function (project) {
    return firebaseApp.database().ref(project + '/' + firebasePaths.wellDepth)
  },
  wells: function (project) {
    return firebaseApp.database().ref(project + '/' + firebasePaths.wells)
  }
}
export let fbPaths = firebasePaths
export let firebaseApp = firebase.initializeApp(config)
export let db = firebaseApp.database()
export let fbauth = firebaseApp.auth()
export let fbTimeStamp = firebase.database.ServerValue.TIMESTAMP
export let firestore = firebaseApp.storage()




// WEBPACK FOOTER //
// ./src/firebase/firebase.js